/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import { useNavigate } from "react-router-dom";
import { NoCameras } from "./NoCamera";
import { CamerasTableAutoPatrol } from "./CamerasTableAutoPatrol";
import {
  AlertState,
  SiteCameras,
} from "./SiteAboutPageUtils/siteAboutInterfaces";
import { useSiteAboutStore } from "./siteAboutStore/siteAboutStore";

type Dispatcher<S> = React.Dispatch<React.SetStateAction<S>>;

export const SiteCamerasTableAutoPatrol = ({
  setAlertState,
  siteCameras,
  setSiteCameras,
  setBackdropLoadingScreenOn,
  setNoAutoAddCamerasDialogOpen,
  siteInfo,
  setSiteInfo,
  setSiteSchedules,
  setActiveTab,
  setDataLoaded,
  setAllSiteSchedules,
  setVmsVariables,
  setArmedStatus,
  setAiLinkSite,
  setSiteDeployed,
  setCamerasNotDeployed,
  setToolTipTitle,
  setConfigureMotion,
  setPatchObject,
  setArmButtonDisabled,
  setRecordingServerData,
  setRecordingServerPatchObject,
  setRecordingServerVisible,
  setHealthCheckData,
  setCamerasRefreshing,
  permissions,
  setWebhooksInfo,
  setWebhooksPatchObject,
  siteSchedules,
}: {
  setAlertState: Dispatcher<AlertState>;
  siteCameras: SiteCameras;
  setSiteCameras: Dispatcher<SiteCameras>;
  setBackdropLoadingScreenOn: Dispatcher<boolean>;
  setNoAutoAddCamerasDialogOpen: Dispatcher<boolean>;
  siteInfo: any;
  setSiteInfo: any;
  setSiteSchedules: any;
  setActiveTab: any;
  setDataLoaded: any;
  setAllSiteSchedules: any;
  setVmsVariables: any;
  setArmedStatus: any;
  setAiLinkSite: any;
  setSiteDeployed: any;
  setCamerasNotDeployed: any;
  setToolTipTitle: any;
  setConfigureMotion: any;
  setPatchObject: any;
  setArmButtonDisabled: any;
  setRecordingServerData: any;
  setRecordingServerPatchObject: any;
  setRecordingServerVisible: Dispatcher<boolean>;
  setHealthCheckData: any;
  setCamerasRefreshing: Dispatcher<boolean>;
  permissions: any;
  setWebhooksInfo: any;
  setWebhooksPatchObject: any;
  siteSchedules: any;
}) => {
  const [selected, setSelected] = React.useState<readonly string[]>([]);
  const navigate = useNavigate();
  const {
    autopatrolCamerasTablePage,
    autopatrolCamerasTableRowsPerPage,
    setAutopatrolCamerasTablePage,
    setAutopatrolCamerasTableRowsPerPage,
  } = useSiteAboutStore();

  React.useEffect(() => {
    const currentIds = new Set(
      siteCameras.results.map((camera) => String(camera.id))
    );
    setSelected((prevSelected) =>
      prevSelected.filter((id) => currentIds.has(String(id)))
    );
  }, [siteCameras.results]);

  React.useEffect(() => {
    setSelected([]);
    setAutopatrolCamerasTablePage(0);
    setAutopatrolCamerasTableRowsPerPage(5);
  }, [siteInfo.id]);

  const hasCameras = siteCameras.results && siteCameras.results.length > 0;

  const setPage: Dispatcher<number> = React.useCallback(
    (value) => {
      setAutopatrolCamerasTablePage(
        typeof value === "function" ? value(autopatrolCamerasTablePage) : value
      );
    },
    [autopatrolCamerasTablePage, setAutopatrolCamerasTablePage]
  );

  const setRowsPerPage: Dispatcher<number> = React.useCallback(
    (value) => {
      setAutopatrolCamerasTableRowsPerPage(
        typeof value === "function"
          ? value(autopatrolCamerasTableRowsPerPage)
          : value
      );
    },
    [autopatrolCamerasTableRowsPerPage, setAutopatrolCamerasTableRowsPerPage]
  );

  const handleSingleCheckboxClick = (
    _event: React.MouseEvent<unknown>,
    id: string | number
  ) => {
    const idStr = String(id);
    const selectedIndex = selected.indexOf(idStr);
    let newSelected: readonly string[] = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, idStr);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const isSelected = (id: string | number) =>
    selected.indexOf(String(id)) !== -1;

  return (
    <>
      {hasCameras ? (
        <CamerasTableAutoPatrol
          navigate={navigate}
          siteCameras={siteCameras}
          page={autopatrolCamerasTablePage}
          rowsPerPage={autopatrolCamerasTableRowsPerPage}
          selected={selected}
          isSelected={isSelected}
          handleSingleCheckboxClick={handleSingleCheckboxClick}
          setSelected={setSelected}
          setPage={setPage}
          setRowsPerPage={setRowsPerPage}
          setBackdropLoadingScreenOn={setBackdropLoadingScreenOn}
          setNoAutoAddCamerasDialogOpen={setNoAutoAddCamerasDialogOpen}
          siteInfo={siteInfo}
          setSiteInfo={setSiteInfo}
          setSiteSchedules={setSiteSchedules}
          setActiveTab={setActiveTab}
          setDataLoaded={setDataLoaded}
          setAllSiteSchedules={setAllSiteSchedules}
          setVmsVariables={setVmsVariables}
          setArmedStatus={setArmedStatus}
          setAiLinkSite={setAiLinkSite}
          setSiteDeployed={setSiteDeployed}
          setCamerasNotDeployed={setCamerasNotDeployed}
          setToolTipTitle={setToolTipTitle}
          setConfigureMotion={setConfigureMotion}
          setPatchObject={setPatchObject}
          setArmButtonDisabled={setArmButtonDisabled}
          setRecordingServerData={setRecordingServerData}
          setRecordingServerPatchObject={setRecordingServerPatchObject}
          setRecordingServerVisible={setRecordingServerVisible}
          setHealthCheckData={setHealthCheckData}
          setCamerasRefreshing={setCamerasRefreshing}
          permissions={permissions}
          setWebhooksInfo={setWebhooksInfo}
          setWebhooksPatchObject={setWebhooksPatchObject}
          siteSchedules={siteSchedules}
          setSiteCameras={setSiteCameras}
          setAlertState={setAlertState}
        />
      ) : (
        <NoCameras
          navigate={navigate}
          setNoAutoAddCamerasDialogOpen={setNoAutoAddCamerasDialogOpen}
        />
      )}
    </>
  );
};
